// Entregas mensais (TESTE) — Operacional › Contratos › 📈 Entregas mensais.
// Reproduz o controle paralelo do diretor de engenharia (planilha "Entregas
// mensais - Projetos 2026"): previsão do mês, baseline × ajuste × realizado,
// metas, prazos, radar de faturamento e conciliação. Doc: docs/entregas-mensais.md
// Não mexe na tela antiga de Controle de Entregas nem no comercial/financeiro.
import { useState } from 'react';
import { App as AntApp, Alert, Tabs } from 'antd';
import AbaMes from './AbaMes';
import AbaPainel from './AbaPainel';
import { AbaFaturamento, AbaPrazos } from './AbaPrazosFaturamento';
import { AbaConciliacao, AbaMetas } from './AbaConciliacaoMetas';

const ABAS = [
  { key: 'mes', label: 'Mês', render: () => <AbaMes /> },
  { key: 'painel', label: 'Painel', render: () => <AbaPainel /> },
  { key: 'prazos', label: 'Prazos', render: () => <AbaPrazos /> },
  { key: 'faturamento', label: 'Radar de faturamento', render: () => <AbaFaturamento /> },
  { key: 'conciliacao', label: 'Conciliação com a planilha', render: () => <AbaConciliacao /> },
  { key: 'metas', label: 'Metas e histórico', render: () => <AbaMetas /> },
];

export default function OperacionalEntregasMensais() {
  const [aba, setAba] = useState(() => {
    try { return sessionStorage.getItem('op:entregas_mensais_aba') || 'mes'; } catch { return 'mes'; }
  });
  const mudar = (k: string) => { setAba(k); try { sessionStorage.setItem('op:entregas_mensais_aba', k); } catch { /* sem storage */ } };
  return (
    <AntApp>
      <Alert type="info" showIcon style={{ marginBottom: 12 }}
        message="Página de teste do controle mensal de entregas"
        description="Entregar aqui não libera faturamento e não altera contratos nem parcelas. A tela antiga de Controle de Entregas continua como está." />
      <Tabs activeKey={aba} onChange={mudar} destroyOnHidden items={ABAS.map(a => ({ key: a.key, label: a.label, children: a.render() }))} />
    </AntApp>
  );
}
